export type SpecialistFilters = {
  text?: string;
  glossary?: string;
  department?: string;
  location?: string;
  spokenLanguage?: string;
  jobFunction?: string;
};

export const specialistFiltersUrlQueryParse = (
  query: string,
  override?: SpecialistFilters
): SpecialistFilters => {
  const filters: SpecialistFilters = {};
  let params;
  try {
    params = new URLSearchParams(query);
  } catch (e) {
    console.warn('Could not parse URL', e);
    return filters;
  }
  for (const [key, val] of params.entries()) {
    if (key === 'query' && val !== '') {
      filters.text = val;
    } else if (key.match(/^f\[\d*]$/)) {
      const [name, value] = val.split(':', 2);
      if (name === 'glossary_az_inhalt_last_name' && value !== '') {
        filters.glossary = value;
      } else if (name === 'klinik_zentrum_oder_institut_inhalt_titel') {
        filters.department = value;
      } else if (name === 'standort_taxonomy_term_name') {
        filters.location = value;
      } else if (name === 'sprachen_taxonomie_begriff_name'){
        filters.spokenLanguage = value;
      } else if (name === 'job_funktionen_taxonomie_begriff_name' && value != '___') {
        filters.jobFunction = value;
      }
    }
  }

  if (override) {
    Object.assign(filters, override);
  }
  return filters;
};

export const specialistFiltersUrlQueryConstruct = (
  filters: SpecialistFilters,
): Record<string, string> => {
  const params: Record<string, string> = {};
  let i = 0;
  if (filters.text) {
    params['query'] = filters.text;
  }
  if (filters.glossary) {
    params[`f[${i++}]`] = `glossary_az_inhalt_last_name:${filters.glossary}`;
  }
  if (filters.department) {
    params[`f[${i++}]`] = `klinik_zentrum_oder_institut_inhalt_titel:${filters.department}`;
  }
  if (filters.location) {
    params[`f[${i++}]`] = `standort_taxonomy_term_name:${filters.location}`;
  }
  if(filters.spokenLanguage) {
    params[`f[${i++}]`] = `sprachen_taxonomie_begriff_name:${filters.spokenLanguage}`;
  }
  if (filters.jobFunction) {
    params[`f[${i++}]`] = `job_funktionen_taxonomie_begriff_name:${filters.jobFunction}`;
  }
  return params;
};
